import { Typography } from 'antd';

const { Text } = Typography;

export function CopyableId({ value }: { value: string }) {
  return (
    <Text copyable={{ text: value }} ellipsis style={{ maxWidth: '100%' }} code>
      {value}
    </Text>
  );
}
